module.exports = __webpack_public_path__ + "static/media/js4.76676bf6.jpg";